import { motion } from 'framer-motion';
import { Shield, Heart, Award, Users } from 'lucide-react';

const values = [
  { icon: Shield, title: 'Trust', desc: 'We sell only 100% genuine products from authorized channels.' },
  { icon: Heart, title: 'Customer First', desc: "Your satisfaction is our priority. We go the extra mile for you." },
  { icon: Award, title: 'Quality Service', desc: 'Expert guidance and prompt after-sales support.' },
  { icon: Users, title: 'Community', desc: 'Proudly serving our local community for over a decade.' },
];

const AboutPage = () => (
  <div>
    <div className="bg-gradient-to-br from-primary to-navy-dark text-primary-foreground py-16 text-center">
      <h1 className="font-heading text-3xl md:text-4xl font-extrabold mb-3">About Us</h1>
      <p className="opacity-80 max-w-lg mx-auto">The story behind Debnath Telecom & Variety Store</p>
    </div>

    <div className="container section-padding">
      <div className="max-w-3xl mx-auto space-y-8">
        <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}>
          <h2 className="font-heading text-2xl font-bold mb-4">Our Story</h2>
          <p className="text-muted-foreground leading-relaxed">
            Debnath Telecom & Variety Store started as a small mobile accessories shop over a decade ago. Through dedication to genuine products, fair pricing, and exceptional customer service, we've grown into a trusted electronics destination for our community. Today, we offer smartphones, LED TVs, home appliances, and accessories from all major brands.
          </p>
        </motion.div>

        <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}>
          <h2 className="font-heading text-2xl font-bold mb-4">Mission & Vision</h2>
          <p className="text-muted-foreground leading-relaxed">
            <strong>Mission:</strong> To provide our customers with genuine, high-quality electronics at the best possible prices, backed by honest guidance and reliable after-sale service.
          </p>
          <p className="text-muted-foreground leading-relaxed mt-3">
            <strong>Vision:</strong> To become the most trusted electronics retailer in our region, known for integrity, customer care, and community involvement.
          </p>
        </motion.div>

        <div>
          <h2 className="font-heading text-2xl font-bold mb-6 text-center">Our Core Values</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            {values.map((v, i) => (
              <motion.div
                key={v.title}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: i * 0.1 }}
                className="bg-card p-6 rounded-xl border shadow-sm"
              >
                <div className="h-10 w-10 rounded-lg bg-secondary flex items-center justify-center mb-3">
                  <v.icon className="h-5 w-5 text-primary" />
                </div>
                <h3 className="font-heading font-semibold mb-1">{v.title}</h3>
                <p className="text-sm text-muted-foreground">{v.desc}</p>
              </motion.div>
            ))}
          </div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 text-center pt-8 border-t">
          {[
            { num: "10+", label: "Years" },
            { num: "5000+", label: "Customers" },
            { num: "20+", label: "Brands" },
            { num: "100%", label: "Genuine" },
          ].map(s => (
            <div key={s.label}>
              <p className="font-heading text-3xl font-extrabold text-primary">{s.num}</p>
              <p className="text-sm text-muted-foreground">{s.label}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  </div>
);

export default AboutPage;
